import { Box, Flex, Image } from "@chakra-ui/react";
import { Airhelp, AirhelpPlus } from "@airhelp/react";
import hills from "../../../assets/images/side_bg_image_2.svg";
import otaHills from "assets/images/side_bg_image_ota_2.svg";
import { DefaultBadges } from "../../../layout/sidebar/badges/LeftNavigationBadges";
import { ReactNode, useState } from "react";
import { useUser } from "v2/modules/auth";
import { useBrandSnapshot } from "v2/modules/branding";
import Logotype from "components/ui-elements/logotype/Logotype";
import { useApplicationLinks } from "v2/settings/applicationLinks";
import { PoweredByLogo } from "./PoweredByLogo";
import { appSettingsSnapshot } from "../../settings";
import { isMobile, isTablet } from "react-device-detect";
import useEffectOnce from "../../../hooks/useEffectOnce";
import { getVariation } from "../../../tracking/tools/optimizely/optimizelyState";
import { MOTIVATORS_EXPERIMENT_CONFIG } from "../../../ab-tests/optimizely-experiments";
import { Motivator } from "../../../funnels/post-eligibility/steps/email/experiment/Motivator";
import { isRtl } from "utils/getLocaleDirection";
const isDesktop = !isMobile && !isTablet;

export function motivatorText(url: string, variation: number | null): string {
  if (url.includes("/email")) {
    if (variation === 1) {
      return "We've won compensation for over 2.3 million customers";
    }
    return "We have more than 138,000 5-star reviews on Trustpilot";
  }
  return "It takes only 2 minutes to submit your claim";
}

export function Sidebar({ content }: { content?: ReactNode }) {
  const { profile } = useUser();
  const brand = useBrandSnapshot();
  const { websitePath } = useApplicationLinks();
  const { locale } = appSettingsSnapshot();
  const [motivatorsVariation, setMotivatorsVariation] = useState<number | null>();
  const url = window.location.pathname;
  const showMotivator = !!motivatorsVariation && isDesktop;

  useEffectOnce(() => {
    const motivatorsVariation = getVariation(MOTIVATORS_EXPERIMENT_CONFIG, locale);
    setMotivatorsVariation(motivatorsVariation);
  });

  const logo = profile?.ahPlusMembership ? (
    <AirhelpPlus w="150px" h="auto" />
  ) : (
    <Airhelp w="150px" h="auto" />
  );

  return (
    <Box
      flex={2}
      display={{ base: "none", xl: "flex" }}
      justifyContent={"flex-end"}
      backgroundColor="greyscale.300"
      minW={"440px"}
    >
      <Flex minH="100vh" position="fixed" direction="column" w="440px">
        <Box flex="1 0 auto" m="48px 64px 32px">
          <Logotype
            logo={brand ? null : logo}
            dataTestId="logo-airhelp"
            logoSrc={brand?.logoUrl}
            logoWidth={brand?.logoWidth}
            href={brand ? brand.siteUrl : websitePath}
          />
          {content}
        </Box>

        {showMotivator && <Motivator text={motivatorText(url, motivatorsVariation)} />}

        <Image
          src={brand ? otaHills : hills}
          alt="hills"
          w="576px"
          maxW="none"
          alignSelf="flex-end"
          transform={isRtl(locale) ? "rotateY(180deg)" : ""}
        />
        <Flex
          mx="64px"
          my={0}
          position="fixed"
          zIndex={10}
          direction="column"
          bottom="64px"
          sx={{
            "@media(height<730px)": { bottom: "32px" },
            "@media(height<700px)": { display: "none" },
          }}
        >
          {brand?.logoPresentInWebapp ? <PoweredByLogo /> : <DefaultBadges />}
        </Flex>
      </Flex>
    </Box>
  );
}
